import React from "react";
import { connect } from "react-redux";

import * as actions from "js/actions/actions";

import { SiteHeader } from "core/SiteHeader";

import { Login, Join } from "./ProfileMenu/styles";

import { authLinks } from "data/links";

import logOutAndRedirect from "helpers/log-out";

import { Context } from "frontend/context/BannersContext";

const LoginLinkUnwrapped = ({ redirect }) => {
    const toEncode = `${window.location.pathname}${window.location.search}`;
    const encodedUrl = encodeURIComponent(toEncode);

    const logIn = e => {
        e.preventDefault();
        redirect(`${authLinks.login.href}?next=${encodedUrl}`);
    };

    return (
        <Login
            data-test="login-link"
            href={authLinks.login.href}
            title={authLinks.login.text}
            onClick={logIn}
        >
            {authLinks.login.text}
        </Login>
    );
};

const LoginLink = connect(null, { redirect: actions.redirect })(
    LoginLinkUnwrapped
);

const JoinLinkUnwrapped = ({ redirect }) => {
    const toEncode = `${window.location.pathname}${window.location.search}`;
    const encodedUrl = encodeURIComponent(toEncode);

    const handleJoin = e => {
        e.preventDefault();
        redirect(`${authLinks.signup.href}?next=${encodedUrl}`);
    };

    return (
        <Join
            href={authLinks.signup.href}
            title={authLinks.signup.text}
            onClick={handleJoin}
        >
            {authLinks.signup.text}
        </Join>
    );
};

const JoinLink = connect(null, { redirect: actions.redirect })(
    JoinLinkUnwrapped
);

class NounProjectHeader extends React.Component {
    static contextType = Context;

    UNSAFE_componentWillMount() {
        this.props.getCurrentUser();
    }

    constructor(props) {
        super(props);
    }

    render() {
        const handleLogOut = () => {
            logOutAndRedirect();
        };

        const currentUser = this.props.currentUser;

        // this code is also in SiteHeaderParent for non legacy pages
        const {
            hideBanner,
            bannerContent,
            bannerContentMobile,
            bannerKey,
            dismissBanner
        } = this.context;

        return (
            <>
                <SiteHeader
                    hideBanner={hideBanner}
                    dismissBanner={dismissBanner}
                    bannerContent={bannerContent}
                    bannerContentMobile={bannerContentMobile}
                    bannerKey={bannerKey}
                    currentUser={currentUser}
                    loginLink={<LoginLink />}
                    joinLink={<JoinLink />}
                    handleLogOut={handleLogOut}
                />
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser = {};

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    const hasTeams =
        currentUser.teams && currentUser.teams.length > 0
            ? currentUser.teams
            : [];

    const currentUserTeams = hasTeams
        .filter(team => {
            return team.user_is_owner;
        })
        .map(team => {
            return {
                name: team.name,
                username: team.slug
            };
        });

    const hasPermissions =
        currentUser.permissions && currentUser.permissions.length > 0
            ? currentUser.permissions
            : {};

    return {
        currentUser: {
            id: currentUser.id,
            username: currentUser.username,
            avatarUrl: currentUser.avatar,
            isCreator: currentUser.creator,
            isSuperuser: currentUser.is_superuser,
            isAnonymous: currentUser.is_anonymous,
            hasSubscription: currentUser.has_premium_account,
            hasNotifications: currentUser.has_notifications,
            hasApiKey: currentUser.has_api_key,
            csrf: currentUser.csrf,
            ownedTeams: currentUserTeams,
            permissions: hasPermissions,
            featureFlags: currentUser.feature_flags,
            isPhotoCreator: currentUser.is_photo_creator,
            isIconCreator: currentUser.is_icon_creator
        }
    };
}

export default connect(mapStateToProps, {
    getCurrentUser: actions.getCurrentUser
})(NounProjectHeader);
